import { createGetAPI } from '@cuemath/rest-api';
import { BASE_URL } from 'constants/api';

const { useGet: useGetRegionalTrialSlots } = createGetAPI({
  getURL: (timezone, region, startHours) =>
    `${BASE_URL}/teachers/regional-trial-slots/?timezone=${timezone}&opportunity_region=${region}&start_hours=${startHours}`,
});

export { useGetRegionalTrialSlots };
